var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookblack2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#045B6A;}\r\n\t.st1{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.5,141.8C283.5,63.5,220,0.1,141.7,0.1S0,63.5,0,141.8c0,70.7,51.8,129.4,119.7,140v-99.1H83.8v-40.9 h35.9v-31.2c0-35.5,21.2-55.1,53.5-55.1c15.5,0,31.8,2.7,31.8,2.7v34.9h-17.9c-17.6,0-23,10.9-23,22.2v26.6h39.4l-6.3,40.9h-33.1 V282C231.6,271.2,283.5,212.5,283.5,141.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.9,182.7l6.3-40.9h-39.4v-26.6c0-11.2,5.4-22.2,23-22.2h17.9V58.1c0,0-16.2-2.7-31.8-2.7 c-32.4,0-53.5,19.6-53.5,55.1v31.2H83.5v40.9h35.9v99.1c7.2,1.1,14.6,1.7,22.2,1.7s14.9-0.6,22.2-1.7v-99.1h33.1V182.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookblack2);
export default __webpack_public_path__ + "static/media/facebookblack2.b402e2ba9917652eed2c3b0ec67ca2fa.svg";
export { ForwardRef as ReactComponent };